export const REGION_MAP = {
    // 印度 (上报印度机房)
    IN: ['IN'],
    // 美国 (上报美国机房)
    US: ['US'],
    // 欧盟 (上报欧盟机房)
    EU: [
        'AT', // 奥地利
        'BE', // 比利时
        'DK', // 丹麦
        'FI', // 芬兰
        'FR', // 法国
        'DE', // 德国
        'GR', // 希腊
        'IE', // 爱尔兰
        'IT', // 意大利
        'LU', // 卢森堡
        'NL', // 荷兰
        'PT', // 葡萄牙
        'ES', // 西班牙
        'SE', // 瑞典
        'HU', // 匈牙利
        'PL', // 波兰
        'CZ', // 捷克
        'SI', // 斯洛文尼亚
        'SK', // 斯洛伐克
        'EE', // 爱沙尼亚
        'LT', // 立陶宛
        'MT', // 马耳他
        'CY', // 塞浦路斯
        'RO', // 罗马尼亚
        'BG', // 保加利亚
        'LV', // 拉脱维亚
        'HR', // 克罗地亚
        'GB', // 大不列颠及北爱尔兰联合王国
        'NO', // 挪威
        'IS', // 冰岛
        'LI', // 列支敦士登
        'CH', // 瑞士
        'TR', // 土耳其
        'MD', // 摩尔多瓦
    ],
    // 其他 (上报新加坡机房)
};

// URL 内容类型 (cType 参数)，与详情页一致
export const URL_CONTENT_TYPE = {
    // 专题内容
    TOPIC: '1',
    // 常规内容
    NORMAL: '0',
} as const;

// 页面样式
export const PAGE_STYLE = {
    // 通栏式
    FULL_WIDTH: '1',
    // 卡片式
    CARD: '2',
} as const;
export const PAGE_STYLE_TEXT = {
    [PAGE_STYLE.FULL_WIDTH]: '通栏式',
    [PAGE_STYLE.CARD]: '卡片式',
} as const;

// 组件分类 - 按展示逻辑分类
export const COMPONENT_CATEGORY = {
    // 顺序组件
    SEQUENTIAL: '1',
    // 插入组件
    INSERTION: '2',
} as const;
export const COMPONENT_CATEGORY_TEXT = {
    [COMPONENT_CATEGORY.SEQUENTIAL]: '顺序组件',
    [COMPONENT_CATEGORY.INSERTION]: '插入组件',
} as const;

// 组件分类 - 按功能分类 (在顺序组件内部的分类)
export const COMPONENT_FUNCTION_TYPE = {
    // 正文组件
    ARTICLE: '1',
    // 推荐组件
    RECOMMENDATION: '2',
} as const;
export const COMPONENT_FUNCTION_TYPE_TEXT = {
    [COMPONENT_FUNCTION_TYPE.ARTICLE]: '正文组件',
    [COMPONENT_FUNCTION_TYPE.RECOMMENDATION]: '推荐组件',
} as const;

// 默认状态（正文展开），与详情页一致
export const DEFAULT_EXPAND = {
    EXPAND: true,
    COLLAPSE: false,
} as const;
export const DEFAULT_EXPAND_TEXT = {
    [String(DEFAULT_EXPAND.EXPAND)]: '默认展开',
    [String(DEFAULT_EXPAND.COLLAPSE)]: '默认收起',
} as const;

// 排序规则
export const SORT_RULE = {
    DEFAULT: '1',
    HOT: '2',
} as const;
export const SORT_RULE_TEXT = {
    [SORT_RULE.DEFAULT]: '兜底规则',
    [SORT_RULE.HOT]: '热度规则',
} as const;

// 「插入组件」的展示位置
export const SWIPE_DISPLAY_POSITION = {
    BELOW_ARTICLE: '1',
    IN_PARAGRAPH: '2',
} as const;
export const SWIPE_DISPLAY_POSITION_TEXT = {
    [SWIPE_DISPLAY_POSITION.BELOW_ARTICLE]: '正文组件下展示',
    [SWIPE_DISPLAY_POSITION.IN_PARAGRAPH]: '正文段落中展示',
} as const;

export const CONTENT_TYPE = {
    TEXT: 'text',
    IMAGE: 'image',
    SUB_TITLE: 'subtitle',
    ARTICLE_COPYRIGHT: 'article_copyright',
    COPYRIGHTED_IMAGE: 'copyrighted_image',
} as const;

// 相关推荐上限
export const MAX_RECOMMEND_NUM = 50;

// 广告平台
export const AD_PLATFORM = {
    // AdSense
    AD_SENSE: '1',
    // AdManager
    AD_MANAGER: '2',
    // Yandex
    YANDEX: '3',
} as const;
export const AD_PLATFORM_TEXT = {
    [AD_PLATFORM.AD_SENSE]: 'AdSense',
    [AD_PLATFORM.AD_MANAGER]: 'AdManager',
    [AD_PLATFORM.YANDEX]: 'Yandex',
} as const;

// 自动广告位置
export const AUTO_AD_POSITION = {
    // 吸顶
    TOP: '1',
    // 吸底
    BOTTOM: '0',
} as const;
export const AUTO_AD_POSITION_TEXT = {
    [AUTO_AD_POSITION.TOP]: '吸顶',
    [AUTO_AD_POSITION.BOTTOM]: '吸底',
} as const;


// 广告宽度
export const SLOT_AD_WIDTH = {
    // 与内容等宽
    EQUAL_TO_CONTENT: '1',
    // 与屏幕等宽
    EQUAL_TO_SCREEN: '2',
} as const;
export const SLOT_AD_WIDTH_TEXT = {
    [SLOT_AD_WIDTH.EQUAL_TO_CONTENT]: '与内容等宽',
    [SLOT_AD_WIDTH.EQUAL_TO_SCREEN]: '与屏幕等宽',
} as const;

// 具体位置
export const EXACT_POSITION = {
    // 文章标题上
    ABOVE_TITLE: '1',
    // 文章标题下
    BELOW_TITLE: '0',
} as const;
export const EXACT_POSITION_TEXT = {
    [EXACT_POSITION.ABOVE_TITLE]: '文章标题上',
    [EXACT_POSITION.BELOW_TITLE]: '文章标题下',
} as const;

// 组件类型
export const AD_TYPE = {
    // 坑位广告
    SLOT_AD: '1',
    // 搜索广告
    SEARCH_AD: '2',
} as const;
export const AD_TYPE_TEXT = {
    [AD_TYPE.SLOT_AD]: '坑位广告',
    [AD_TYPE.SEARCH_AD]: '搜索广告',
} as const;

// 埋点类型（与详情页一致）
export const TRACKING_MID = {
    // 组件间广告
    BETWEEN_COMPONENT: '0',
    // 推荐间广告
    BETWEEN_RECOMMEND: '1',
    // 推荐内
    RECOMMEND: '2',
    // 正文内
    ARTICLE: '3',
} as const;
export const TRACKING_MID_TEXT = {
    [TRACKING_MID.BETWEEN_COMPONENT]: '组件间广告',
    [TRACKING_MID.BETWEEN_RECOMMEND]: '推荐间广告',
    [TRACKING_MID.RECOMMEND]: '推荐内',
    [TRACKING_MID.ARTICLE]: '正文内',
} as const;

// 广告高度
export const SLOT_AD_HEIGHT = {
    // 设置固定高度
    FIXED: '1',
    // 设置高度上限
    UPPER_LIMIT: '2',
    // 根据宽度设置高度
    ACCORDING_TO_WIDTH: '3',
} as const;
export const SLOT_AD_HEIGHT_TEXT = {
    [SLOT_AD_HEIGHT.FIXED]: '设置固定高度',
    [SLOT_AD_HEIGHT.UPPER_LIMIT]: '设置高度上限',
    [SLOT_AD_HEIGHT.ACCORDING_TO_WIDTH]: '根据宽度设置高度',
} as const;

// 域名
export const DOMAIN = {
    // actimg.heytapimg.com
    HEYTAPIMG: '1',
    // contents.lsmagazineimg.com
    LS_MAGAZINE_IMG: '2',
} as const;
export const DOMAIN_TEXT = {
    [DOMAIN.HEYTAPIMG]: 'actimg.heytapimg.com',
    [DOMAIN.LS_MAGAZINE_IMG]: 'contents.lsmagazineimg.com',
} as const;

// 广告预加载距离
export const AD_PRELOAD_DISTANCE = {
    // 0.5 屏
    HALF_SCREEN: '0.5',
    // 1 屏
    ONE_SCREEN: '1',
    // 1.5 屏
    ONE_AND_HALF_SCREEN: '1.5',
    // 2 屏
    TWO_SCREEN: '2',
} as const;
export const AD_PRELOAD_DISTANCE_TEXT = {
    [AD_PRELOAD_DISTANCE.HALF_SCREEN]: '0.5 屏',
    [AD_PRELOAD_DISTANCE.ONE_SCREEN]: '1 屏',
    [AD_PRELOAD_DISTANCE.ONE_AND_HALF_SCREEN]: '1.5 屏',
    [AD_PRELOAD_DISTANCE.TWO_SCREEN]: '2 屏',
} as const;


// 组件类型
export const COMPONENT_TYPE = {
    // 非沉浸式正文组件
    STANDARD_ARTICLE: '1',
    // 沉浸式正文组件
    IMMERSIVE_ARTICLE: '2',
    // 相关推荐列表组件
    LIST_RECOMMENDATION: '3',
    // 相关推荐大卡组件
    CARD_RECOMMENDATION: '4',
    // 相关推荐横划组件
    SWIPE_RECOMMENDATION: '5',
    // 小游戏组件
    MINI_GAME: '6',
    // 轻读卡-正文组件
    LIGHT_READING_ARTICLE: '7',
    // 轻读卡-推荐组件
    LIGHT_READING_RECOMMENDATION: '8',
} as const;
export const COMPONENT_TYPE_TEXT = {
    [COMPONENT_TYPE.STANDARD_ARTICLE]: '非沉浸式正文组件',
    [COMPONENT_TYPE.IMMERSIVE_ARTICLE]: '沉浸式正文组件',
    [COMPONENT_TYPE.LIST_RECOMMENDATION]: '相关推荐列表组件',
    [COMPONENT_TYPE.CARD_RECOMMENDATION]: '相关推荐大卡组件',
    [COMPONENT_TYPE.SWIPE_RECOMMENDATION]: '相关推荐横划组件',
    [COMPONENT_TYPE.MINI_GAME]: '小游戏组件',
    [COMPONENT_TYPE.LIGHT_READING_ARTICLE]: '轻读卡-正文组件',
    [COMPONENT_TYPE.LIGHT_READING_RECOMMENDATION]: '轻读卡-推荐组件',
} as const;